import PropTypes from 'prop-types'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

import { Box, Container } from '@redriverpress/system'

const Tab = styled(NavLink).attrs(() => ({
  activeClassName: 'active',
}))`
  align-items: center;
  background: transparent;
  border-bottom: 4px solid transparent;
  color: ${props => props.theme.colors.gray700};
  display: inline-flex;
  font-weight: 600;
  padding: ${props => props.theme.space[3]} 0;
  position: relative;

  &.active {
    border-bottom: 4px solid ${props => props.theme.colors.blue700};
    color: ${props => props.theme.colors.black};
  }
`
Tab.displayName = 'Tab'

// Some tabs use objects for their `to`
// and some use React nodes for their `label`,
// so generating a key without relying on the index gets interesting…
export const getTabKey = tab => {
  if (typeof tab.to === 'string') return tab.to
  if (typeof tab.label === 'string') return tab.label
  return JSON.stringify(tab.to)
}

export const TabsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    // Expects a React Router location prop, see:
    // https://reactrouter.com/web/api/NavLink
    to: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.object,
      PropTypes.string,
    ]).isRequired,
    exact: PropTypes.bool,
    // Prefer string labels where possible; if you need to pass a node,
    // ensure the wrapping component is a React Fragment in order to preserve
    // the effects of the grid layout on the grid container's immediate children.
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    // currently only showing on $sm and $md
    icon: PropTypes.string,
  })
)

export default function Tabs({ tabs }) {
  return (
    <Container>
      <Box
        as='nav'
        display='inline-grid'
        gridAutoFlow='column'
        gridGap={['1.5rem', null, '2rem']}
      >
        {tabs.map(tab => (
          <Tab exact={tab.exact} to={tab.to} key={getTabKey(tab)}>
            {tab.label}
          </Tab>
        ))}
      </Box>
    </Container>
  )
}

Tabs.propTypes = {
  tabs: TabsPropType.isRequired,
}
